var map = {
	"./Dark-Paws.png": 247,
	"./Light-Paws.png": 246,
	"./arrow-down-blue.svg": 470,
	"./arrow-down-grey.svg": 471,
	"./arrow-right-white.png": 472,
	"./arrow-right.svg": 473,
	"./big_unicorn.png": 240,
	"./blue-loader.svg": 79,
	"./circle-grey.svg": 474,
	"./circle.svg": 475,
	"./coinbaseWalletIcon.svg": 145,
	"./dropdown-blue.svg": 476,
	"./dropdown.svg": 477,
	"./dropup-blue.svg": 478,
	"./ethereum-logo.png": 248,
	"./fortmaticIcon.png": 146,
	"./kishu-character.png": 249,
	"./link.svg": 479,
	"./magnifying-glass.svg": 480,
	"./menu.svg": 481,
	"./metamask.png": 149,
	"./noise.png": 242,
	"./plus-blue.svg": 482,
	"./plus-grey.svg": 483,
	"./portisIcon.png": 147,
	"./question-mark.svg": 484,
	"./question.svg": 485,
	"./simpleHoldIcon.svg": 486,
	"./spinner.svg": 487,
	"./token-list-logo.png": 488,
	"./token-list/lists-dark.png": 489,
	"./token-list/lists-light.png": 490,
	"./token-logo-uni.png": 491,
	"./token-logo.png": 74,
	"./tokenlistsgrouped.png": 492,
	"./trustWallet.png": 493,
	"./walletConnectIcon.svg": 148,
	"./x.svg": 494,
	"./xl_uni.png": 241
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 207;